import { render } from "./banner-button-v2.vue?vue&type=template&id=19034944"
import script from "./banner-button-v2.vue?vue&type=script&lang=js"
export * from "./banner-button-v2.vue?vue&type=script&lang=js"

import "./banner-button-v2.vue?vue&type=style&index=0&id=19034944&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__